export default __webpack_public_path__ + "static/media/branding-bold-webfont.0ad21dac.woff2";